import { IPreCasInterview } from '../../../types';
export type PreCasInterviewState = IPreCasInterview;

export enum PreCasInterviewTypes {
  UPDATE_PCI_FIELD = '@@visa/preCasInterview/UPDATE_PCI_FIELD',
  RESET_PCI_QUESTIONS = '@@visa/preCasInterview/RESET_PCI_QUESTIONS',
}

export enum Pages {
  RESET_INTERVIEW = 'uni-pc-reset-interview',
  PAGE1 = 'uni-pc-step1',
  PAGE2 = 'uni-pc-step2',
  PAGE3 = 'uni-pc-step3',
  PAGE4 = 'uni-pc-step4',
}
